export default __webpack_public_path__ + "static/media/Christmas_16.685e53f5.png";